import { Navigate, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import { AdminService } from '../services/AdminService';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const AdminRoute = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  const { data: isAdmin, isLoading } = useQuery(
    ['isAdmin', currentUser?.uid],
    () => AdminService.isAdmin(),
    {
      enabled: !!currentUser
    }
  );

  if (!currentUser) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminRoute; 